import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Link } from 'react-router-dom'
import { Routes } from 'app/services/routeService/routeService'
import { useAppLogo } from 'commons/usePartner'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .logo-icon': {
      transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
    '& .react-badge, & .logo-text': {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
  },
  reactBadge: {
    backgroundColor: 'rgba(0,0,0,0.6)',
    color: '#61DAFB',
  },
}))

function Logo() {
  const classes = useStyles()
  const { banner: appBanner } = useAppLogo()

  return (
    <div className={clsx(classes.root, 'flex-1 flex-shrink-0')}>
      <Link to={Routes.notificationTimeline()} className="block no-underline">
        <img
          className="logo-icon min-h-40 max-h-76 object-contain"
          src={appBanner}
          alt="logo"
        />
      </Link>
    </div>
  )
}

export default Logo
